import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { isUndefined } from 'util';

interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  { name: 'vk', src: 'https://vk.com/js/api/xd_connection.js' },
  { name: 'green-player', src: '/assets/js/green-audio-player/js/green-audio-player.js' },
  {
    name: 'amplitudejs',
    src: 'https://cdn.jsdelivr.net/npm/amplitudejs/dist/amplitude.js'
  },
  { name: 'michaelbromley', src: '/assets/js/michaelbromley.js' },
  { name: 'fancybox', src: '/assets/js/fancybox/jquery.fancybox.min.js' },
  { name: 'wavesurfer', src: '/assets/js/wavesurfer/wavesurfer.js' },
  { name: 'dropzone', src: '/assets/js/dropzone/min/dropzone.min.js' },
  {
    name: 'yandex-map',
    src: 'https://api-maps.yandex.ru/2.1/?apikey=3515df07-dde2-45b0-b505-45989acd89ac&lang=ru_RU'
  },
  {
    name: 'tgs-player',
    src: 'https://unpkg.com/@lottiefiles/lottie-player@0.4.0/dist/tgs-player.js'
  },
  {
    name: 'html2canvas',
    src: 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.4.1/html2canvas.min.js'
  },
  { name: 'peerjs', src: 'https://unpkg.com/peerjs@1.3.1/dist/peerjs.min.js' },
  { name: 'lightgallery', src: '/assets/js/lightgallery/js/lightgallery.js?t=1' },
  { name: 'lg-thumbnail', src: '/assets/js/lightgallery/js/lg-thumbnail.js' },
  { name: 'lg-zoom', src: '/assets/js/lightgallery/js/lg-zoom.js' },
  { name: 'lg-share', src: '/assets/js/lightgallery/js/lg-share.js' },
  { name: 'lg-rotate', src: '/assets/js/lightgallery/js/lg-rotate.js' },
  { name: 'lg-fullscreen', src: '/assets/js/lightgallery/js/lg-fullscreen.js' },
  { name: 'lg-video', src: '/assets/js/lightgallery/js/lg-video.js' },

  {
    name: 'qrcode',
    src: 'https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js'
  },
  { name: 'jquery', src: '/assets/js/libs/jquery.min.js' }
];
// http://www.lukasjakob.com/how-to-dynamically-load-external-scripts-in-angular/
declare const document: any;

@Injectable()
export class DynamicScriptLoaderService {
  private scripts: any = {};
  private styles: any = {};

  constructor(@Inject(DOCUMENT) private document: Document) {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }
  loadStyle(styleName: string, id = 'client-theme') {
    if (isUndefined(this.styles[id])) {
      this.styles[id] = true;
      const head = this.document.getElementsByTagName('head')[0];

      const themeLink = this.document.getElementById(id) as HTMLLinkElement;
      if (themeLink) {
        themeLink.href = styleName;
      } else {
        const style = this.document.createElement('link');
        style.id = id;
        style.rel = 'stylesheet';
        style.href = `${styleName}`;

        head.appendChild(style);
      }
    }
  }
  load(scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.scripts[name].loaded) {
        this.scripts[name].loaded = true;
        // load script
        const script: any = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {
          // IE
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              // this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {
          // Others
          script.onload = () => {
            // this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
    });
  }
}
